export default __webpack_public_path__ + "static/media/public-safety-replay-panel.en.abda455a.vtt";